import * as Yup from 'yup';

import { phoneNumber, validateCheckoutAmount } from 'utils/validation';

import { CheckFormValues } from './types';

export const initialValues: CheckFormValues = {
  amount: '',
  holderName: '',
  checkNumber: '',
  phoneNumber: '',
  driverLicense: '',
};

// Owner 19 Oct 2026: a check may be written for more than the amount due;
// the difference is change in cash. With nothing due, a check is still
// refused (as before).
export const getValidationSchema = (amount: number) =>
  Yup.object().shape({
    checkNumber: Yup.number().required(),
    amount:
      amount > 0
        ? Yup.number().positive().required()
        : validateCheckoutAmount(amount),
    driverLicense: Yup.string().required(),
    phoneNumber: phoneNumber('phoneNumber'),
    holderName: Yup.string().min(3).required(),
  });
